import { render, staticRenderFns } from "./StatisticsStakingChart.vue?vue&type=template&id=cacaf7ce&"
import script from "./StatisticsStakingChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsStakingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports